import type { TFunction } from 'i18next';
import { z } from 'zod';

export const createValidationMessages = (t: TFunction) => ({
  email: () => t('validation.email'),
  max: (max: number) => t('validation.max', { max }),
  min: (min: number) => t('validation.min', { min }),
  minLength: (min: number) => t('validation.minLength', { min }),
  number: () => t('validation.number'),
  required: () => t('validation.required'),
  url: () => t('validation.url'),
});

export const createRequiredString = (t: TFunction) =>
  z.string().min(1, { message: t('validation.required') });

export const createOptionalString = () => z.string().optional();

export const createRequiredNumber = (t: TFunction, min = 0) =>
  z.number({ message: t('validation.number') }).min(min, {
    message: t('validation.min', { min }),
  });
